(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-bkp"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mega-try"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-seo-bak-20260908"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inopro-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ilp]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const form = root.querySelector('[data-ilp-form]');
      const button = form.querySelector('button[type="submit"]');
      const buttons = [...new Set([button, ...root.querySelectorAll('[data-ilp-add]')])];
      const labels = new Map(buttons.map(control => [control, control.textContent]));
      const status = root.querySelector('[data-ilp-status]');
      const cartLink = root.querySelector('[data-ilp-cart-link]');
      const sticky = root.querySelector('[data-ilp-sticky]');
      const buy = root.querySelector('.ilp-buybox');
      const final = root.querySelector('.ilp-final');

      const countdowns = [...root.querySelectorAll('[data-ilp-countdown]')];
      let stopCountdown = () => {};
      if (countdowns.length) {
        const clocks = countdowns.map(countdown => countdown.querySelector('[data-ilp-clock]'));
        const visibleCountdowns = new Set();
        const key = 'inopro-routine-window-v1';
        const duration = 5 * 60 * 60 * 1000;
        let end = 0, tick = 0, inView = false, observer;
        const expire = () => {
          clearInterval(tick);
          observer?.disconnect();
          countdowns.forEach(countdown => countdown.remove());
          document.removeEventListener('visibilitychange', sync);
          window.removeEventListener('storage', onStorage);
        };
        const render = () => {
          const remaining = Math.ceil((end - Date.now()) / 1000);
          if (remaining <= 0 || remaining > duration / 1000) { expire(); return false; }
          const hours = Math.floor(remaining / 3600);
          const minutes = Math.floor(remaining % 3600 / 60);
          const seconds = remaining % 60;
          const text = [hours, minutes, seconds].map(n => String(n).padStart(2, '0')).join(':');
          clocks.forEach(clock => {
            clock.textContent = text;
            clock.dateTime = 'PT' + hours + 'H' + minutes + 'M' + seconds + 'S';
          });
          countdowns.forEach(countdown => { countdown.hidden = false; });
          return true;
        };
        const sync = () => {
          clearInterval(tick);
          if (render() && inView && !document.hidden) tick = setInterval(render, 1000);
        };
        const onStorage = event => {
          if (event.key !== key) return;
          const next = Number(event.newValue);
          if (!Number.isFinite(next) || next <= 0) { expire(); return; }
          end = Math.min(end, next);
          sync();
        };
        try {
          const saved = localStorage.getItem(key);
          end = saved === null ? Date.now() + duration : Number(saved);
          if (saved === null) localStorage.setItem(key, String(end));
          if (!Number.isFinite(end) || end <= 0) throw new Error('Invalid countdown');
          if (render()) {
            document.addEventListener('visibilitychange', sync);
            window.addEventListener('storage', onStorage);
            if ('IntersectionObserver' in window) {
              observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) visibleCountdowns.add(entry.target);
                  else visibleCountdowns.delete(entry.target);
                });
                inView = visibleCountdowns.size > 0;
                sync();
              }, {rootMargin:'100px'});
              countdowns.forEach(countdown => observer.observe(countdown));
            } else { inView = true; sync(); }
          }
        } catch (_) { expire(); }
        stopCountdown = expire;
      }
      let busy = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || button.disabled) return;
        busy = true;
        buttons.forEach(control => {
          control.disabled = true;
          control.setAttribute('aria-busy', 'true');
          control.textContent = root.dataset.adding;
        });
        status.textContent = '';
        const items = [...form.querySelectorAll('[data-ilp-variant]')].map(input => ({id: input.value, quantity: 1}));
        if (!items.length || items.some(item => !/^\d+$/.test(item.id))) {
          status.textContent = root.dataset.error;
          buttons.forEach(control => {control.removeAttribute('aria-busy');control.textContent = root.dataset.check;});
          cartLink.hidden = false;
          return;
        }
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 20000);
        let confirmed = false;
        try {
          const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const canRender = drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function';
          const sections = canRender ? drawer.getSectionsToRender() : [];
          const payload = {items};
          if (sections.length) {
            payload.sections = sections.map(section => section.id).slice(0, 5);
            payload.sections_url = location.pathname;
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(event.submitter || button);
          }
          const response = await fetch(form.action + '.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(payload), signal:controller.signal});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error('unconfirmed');
          confirmed = true;
          cartLink.hidden = false;
          status.textContent = root.dataset.added;
          const complete = sections.length && sections.every(section => typeof result.sections?.[section.id] === 'string' && new DOMParser().parseFromString(result.sections[section.id], 'text/html').querySelector(section.selector || '.shopify-section'));
          if (complete) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'inopro-campaign',cartData:result});
          } else {
            location.assign(cartLink.href);
          }
          buttons.forEach(control => {control.textContent = labels.get(control);control.disabled = false;});
          busy = false;
        } catch (_) {
          status.textContent = confirmed ? root.dataset.added : root.dataset.uncertain;
          buttons.forEach(control => {control.textContent = root.dataset.check;});
          cartLink.hidden = false;
          cartLink.focus();
        } finally {
          clearTimeout(timer);
          buttons.forEach(control => control.removeAttribute('aria-busy'));
        }
      });
      let queued = false, buyPassed = false, finalReached = false;
      let positionObserver, posterObserver;
      const videos = [...root.querySelectorAll('video')];
      const loadPoster = video => {
        if (!video.dataset.ilpPoster) return;
        video.poster = video.dataset.ilpPoster;
        delete video.dataset.ilpPoster;
      };
      const updateSticky = () => {
        queued = false;
        const playing = videos.some(video => !video.paused && !video.ended);
        const hidden = playing || !buyPassed || finalReached;
        if (sticky.hidden !== hidden) sticky.hidden = hidden;
      };
      const measureFallback = () => {
        queued = false;
        buyPassed = buy.getBoundingClientRect().bottom <= 0;
        finalReached = final.getBoundingClientRect().top <= window.innerHeight;
        const nearby = videos.filter(video => video.dataset.ilpPoster && video.getBoundingClientRect().top < window.innerHeight + 600);
        nearby.forEach(loadPoster);
        updateSticky();
      };
      const queueSticky = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(positionObserver ? updateSticky : measureFallback);
      };
      videos.forEach(video => {
        video.addEventListener('play', () => {
          loadPoster(video);
          videos.forEach(other => {if (other !== video) other.pause();});
          queueSticky();
        });
        video.addEventListener('pause', queueSticky);
        video.addEventListener('ended', queueSticky);
      });
      if ('IntersectionObserver' in window) {
        positionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === buy) buyPassed = entry.boundingClientRect.bottom <= 0;
            if (entry.target === final) finalReached = entry.boundingClientRect.top <= (entry.rootBounds?.bottom ?? window.innerHeight);
          });
          updateSticky();
        });
        positionObserver.observe(buy);
        positionObserver.observe(final);
        posterObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            loadPoster(entry.target);
            posterObserver.unobserve(entry.target);
          });
        }, {rootMargin:'600px 0px'});
        videos.forEach(video => posterObserver.observe(video));
      } else {
        window.addEventListener('scroll', queueSticky, {passive:true});
        window.addEventListener('resize', queueSticky, {passive:true});
        queueSticky();
      }
      const unload = event => {
        if (!event.target.contains(root)) return;
        stopCountdown();
        positionObserver?.disconnect();
        posterObserver?.disconnect();
        window.removeEventListener('scroll', queueSticky);
        window.removeEventListener('resize', queueSticky);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumin-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ilp]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const form = root.querySelector('[data-ilp-form]');
      const button = form.querySelector('button[type="submit"]');
      const buttons = [...new Set([button, ...root.querySelectorAll('[data-ilp-add]')])];
      const labels = new Map(buttons.map(control => [control, control.textContent]));
      const status = root.querySelector('[data-ilp-status]');
      const cartLink = root.querySelector('[data-ilp-cart-link]');
      const sticky = root.querySelector('[data-ilp-sticky]');
      const buy = root.querySelector('.ilp-buybox');
      const final = root.querySelector('.ilp-final');

      const countdowns = [...root.querySelectorAll('[data-ilp-countdown]')];
      let stopCountdown = () => {};
      if (countdowns.length) {
        const clocks = countdowns.map(countdown => countdown.querySelector('[data-ilp-clock]'));
        const visibleCountdowns = new Set();
        const key = 'inopro-routine-window-v1';
        const duration = 5 * 60 * 60 * 1000;
        let end = 0, tick = 0, inView = false, observer;
        const expire = () => {
          clearInterval(tick);
          observer?.disconnect();
          countdowns.forEach(countdown => countdown.remove());
          document.removeEventListener('visibilitychange', sync);
          window.removeEventListener('storage', onStorage);
        };
        const render = () => {
          const remaining = Math.ceil((end - Date.now()) / 1000);
          if (remaining <= 0 || remaining > duration / 1000) { expire(); return false; }
          const hours = Math.floor(remaining / 3600);
          const minutes = Math.floor(remaining % 3600 / 60);
          const seconds = remaining % 60;
          const text = [hours, minutes, seconds].map(n => String(n).padStart(2, '0')).join(':');
          clocks.forEach(clock => {
            clock.textContent = text;
            clock.dateTime = 'PT' + hours + 'H' + minutes + 'M' + seconds + 'S';
          });
          countdowns.forEach(countdown => { countdown.hidden = false; });
          return true;
        };
        const sync = () => {
          clearInterval(tick);
          if (render() && inView && !document.hidden) tick = setInterval(render, 1000);
        };
        const onStorage = event => {
          if (event.key !== key) return;
          const next = Number(event.newValue);
          if (!Number.isFinite(next) || next <= 0) { expire(); return; }
          end = Math.min(end, next);
          sync();
        };
        try {
          const saved = localStorage.getItem(key);
          end = saved === null ? Date.now() + duration : Number(saved);
          if (saved === null) localStorage.setItem(key, String(end));
          if (!Number.isFinite(end) || end <= 0) throw new Error('Invalid countdown');
          if (render()) {
            document.addEventListener('visibilitychange', sync);
            window.addEventListener('storage', onStorage);
            if ('IntersectionObserver' in window) {
              observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) visibleCountdowns.add(entry.target);
                  else visibleCountdowns.delete(entry.target);
                });
                inView = visibleCountdowns.size > 0;
                sync();
              }, {rootMargin:'100px'});
              countdowns.forEach(countdown => observer.observe(countdown));
            } else { inView = true; sync(); }
          }
        } catch (_) { expire(); }
        stopCountdown = expire;
      }
      let busy = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || button.disabled) return;
        busy = true;
        buttons.forEach(control => {
          control.disabled = true;
          control.setAttribute('aria-busy', 'true');
          control.textContent = root.dataset.adding;
        });
        status.textContent = '';
        const items = [...form.querySelectorAll('[data-ilp-variant]')].map(input => ({id: input.value, quantity: 1}));
        if (!items.length || items.some(item => !/^\d+$/.test(item.id))) {
          status.textContent = root.dataset.error;
          buttons.forEach(control => {control.removeAttribute('aria-busy');control.textContent = root.dataset.check;});
          cartLink.hidden = false;
          return;
        }
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 20000);
        let confirmed = false;
        try {
          const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const canRender = drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function';
          const sections = canRender ? drawer.getSectionsToRender() : [];
          const payload = {items};
          if (sections.length) {
            payload.sections = sections.map(section => section.id).slice(0, 5);
            payload.sections_url = location.pathname;
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(event.submitter || button);
          }
          const response = await fetch(form.action + '.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(payload), signal:controller.signal});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error('unconfirmed');
          confirmed = true;
          cartLink.hidden = false;
          status.textContent = root.dataset.added;
          const complete = sections.length && sections.every(section => typeof result.sections?.[section.id] === 'string' && new DOMParser().parseFromString(result.sections[section.id], 'text/html').querySelector(section.selector || '.shopify-section'));
          if (complete) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'inopro-campaign',cartData:result});
          } else {
            location.assign(cartLink.href);
          }
          buttons.forEach(control => {control.textContent = labels.get(control);control.disabled = false;});
          busy = false;
        } catch (_) {
          status.textContent = confirmed ? root.dataset.added : root.dataset.uncertain;
          buttons.forEach(control => {control.textContent = root.dataset.check;});
          cartLink.hidden = false;
          cartLink.focus();
        } finally {
          clearTimeout(timer);
          buttons.forEach(control => control.removeAttribute('aria-busy'));
        }
      });
      let queued = false, buyPassed = false, finalReached = false;
      let positionObserver, posterObserver;
      const videos = [...root.querySelectorAll('video')];
      const loadPoster = video => {
        if (!video.dataset.ilpPoster) return;
        video.poster = video.dataset.ilpPoster;
        delete video.dataset.ilpPoster;
      };
      const updateSticky = () => {
        queued = false;
        const playing = videos.some(video => !video.paused && !video.ended);
        const hidden = playing || !buyPassed || finalReached;
        if (sticky.hidden !== hidden) sticky.hidden = hidden;
      };
      const measureFallback = () => {
        queued = false;
        buyPassed = buy.getBoundingClientRect().bottom <= 0;
        finalReached = final.getBoundingClientRect().top <= window.innerHeight;
        const nearby = videos.filter(video => video.dataset.ilpPoster && video.getBoundingClientRect().top < window.innerHeight + 600);
        nearby.forEach(loadPoster);
        updateSticky();
      };
      const queueSticky = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(positionObserver ? updateSticky : measureFallback);
      };
      videos.forEach(video => {
        video.addEventListener('play', () => {
          loadPoster(video);
          videos.forEach(other => {if (other !== video) other.pause();});
          queueSticky();
        });
        video.addEventListener('pause', queueSticky);
        video.addEventListener('ended', queueSticky);
      });
      if ('IntersectionObserver' in window) {
        positionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === buy) buyPassed = entry.boundingClientRect.bottom <= 0;
            if (entry.target === final) finalReached = entry.boundingClientRect.top <= (entry.rootBounds?.bottom ?? window.innerHeight);
          });
          updateSticky();
        });
        positionObserver.observe(buy);
        positionObserver.observe(final);
        posterObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            loadPoster(entry.target);
            posterObserver.unobserve(entry.target);
          });
        }, {rootMargin:'600px 0px'});
        videos.forEach(video => posterObserver.observe(video));
      } else {
        window.addEventListener('scroll', queueSticky, {passive:true});
        window.addEventListener('resize', queueSticky, {passive:true});
        queueSticky();
      }
      const unload = event => {
        if (!event.target.contains(root)) return;
        stopCountdown();
        positionObserver?.disconnect();
        posterObserver?.disconnect();
        window.removeEventListener('scroll', queueSticky);
        window.removeEventListener('resize', queueSticky);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
